export const BASE_URL = "http://localhost:3300/api-telcel-sierra/v1";

export const BASE_URL_DEV =
  "https://prod.sierra-movil-backend.com/api-telcel-sierra/v1";

export const BASE_URL_FACTURA = "https://app.facturadigital.com.mx/api";

export const X_API_KEY =
  "TU9TUzY5MDEyM1REOS02NzRjYjJhNS1hMGI1LTQ3NDAtYjU5OS1jMjljNTZjNGU3ZTQ=";

export const API_USUARIO_FACTURA = "MOSS690123TD9";

export const API_PASSWORD_FACTURA = "JALSGM001";
/*
  local = "http://localhost:3300/api-telcel-sierra/v1"
  develop = "https://development.sierra-movil-backend.com/api-telcel-sierra/v1"
  production = "https://prod.sierra-movil-backend.com/api-telcel-sierra/v1"
  */
